import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const BetTypeDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and ${breakpoints.tablet.max.sm} {
    display: none;
  }
`;
